<h2 mat-dialog-title>
  <i class="fa fa-object-group" aria-hidden="true"></i>&nbsp; Merge Buyers Groups
</h2>
<form [formGroup]="formGroup" (submit)="merge()">
  <mat-dialog-content>
    <mat-form-field class="name-field">
      <mat-label>Group Name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
    <label class="groups-selection-title">Please select groups to be merged</label>
    <div class="groups-list">
      @for (group of groups; track group.group_id) {
        <mat-checkbox
          [checked]="selectedGroupIds.has(group.group_id)"
          (change)="toggleGroup(group.group_id)">
          {{ group.name }}
        </mat-checkbox>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" color="primary"><i class="fa fa-fw fa-save" aria-hidden="true"></i> Merge Groups</button>
  </mat-dialog-actions>
</form>
